import { Table } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { EmptyState } from '@/components/ui/empty-state';

interface TableEmptyStateProps {
  colSpan: number;
  title: string;
  description?: string;
  icon?: ReactNode;
  children?: ReactNode;
}

const TableEmptyState = ({ colSpan, title, description, icon, children }: TableEmptyStateProps) => (
  <Table.Row data-table-empty-row>
    <Table.Cell colSpan={colSpan} py={0}>
      <EmptyState title={title} description={description} icon={icon} py={12}>
        {children}
      </EmptyState>
    </Table.Cell>
  </Table.Row>
);

export default TableEmptyState;
